module.exports = __webpack_public_path__ + "img/GS_Profile-Lungisa Taitai.3080bbd7.png";